import { render, staticRenderFns } from "./VendorsPage.vue?vue&type=template&id=254b1efe&scoped=true&"
import script from "./VendorsPage.vue?vue&type=script&lang=js&"
export * from "./VendorsPage.vue?vue&type=script&lang=js&"
import style0 from "./VendorsPage.vue?vue&type=style&index=0&id=254b1efe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254b1efe",
  null
  
)

export default component.exports